module.exports = __webpack_public_path__ + "static/media/ic_invest_build_wealth.d5855058.svg";